import React from 'react'
import { components, type GroupHeadingProps } from 'react-select'

import SectionHeader from '../../SectionHeader/SectionHeader'

const GroupHeading = <OptionType,>(
  props: GroupHeadingProps<OptionType>,
): React.JSX.Element => {
  //@ts-expect-error The GroupBase<OptionType> from react-select does not recognize the rightLabel prop. We have added this ourselves, but it causes a type error with react-select.
  const { label, rightLabel } = props.data
  return (
    <components.GroupHeading {...props}>
      <SectionHeader title={label ?? ''} rightDisplay={rightLabel ?? ''} />
    </components.GroupHeading>
  )
}

export default GroupHeading
